import React from "react";
import Main from "../../components/main";
import Box from "../../components/box";
import P from "../../components/p";
import "./styles.css";

const PrivacyPolicy = () => (
  <div className="privacy">
    <Main>
      <Box>
        <h1>Privacy Policy</h1>
        <h2>How do we collect your personal details?</h2>
        <P>
          When you sign up for our service with a third-party account like
          Google, we store your account's email address. We do not have access
          to the password or other details of your third-party account.
        </P>
        <h2>What other data do we collect from you?</h2>
        <P>
          When you use Ghast, we may collect various usage data and errors to
          make future improvements to our service and solve your problems more
          efficiently.
        </P>
        <h2>Do we share your information with third parties?</h2>
        <P>
          No, any data we collect from you, solely serves the purpose of
          potentially improving our service. We do not share or sell any
          information to third-parties.
        </P>
      </Box>
    </Main>
  </div>
);

export default PrivacyPolicy;



/** WEBPACK FOOTER **
 ** ./src/views/pages/privacyPolicy/index.js
 **/